module.exports = __webpack_public_path__ + "img/4_167.a045630b.png";